import {
  Condition,
  ConditionType,
  FormCondition,
  SpecialConditionData,
} from '@urbanx/agx.campaigns.client';
import { AgxOnOrDaysFrom, ContractDateType } from '@urbanx/agx.ui-components2';

interface MandatorySpecialConditionDueDateProps {
  id: string;
  dueDate: FormCondition | undefined;
  specialConditions: SpecialConditionData[];
  campaignId: string;
  validate: boolean;
  onChange: (dueDate: FormCondition) => void;
}

const conditionsToInclude: Condition[] = [
  Condition.OnDate,
  Condition.NdaysFromDate,
  Condition.OnSpecificDate,
  Condition.AsPerContract,
];

export function MandatorySpecialConditionDueDate({
  id,
  dueDate,
  specialConditions,
  campaignId,
  validate,
  onChange,
}: MandatorySpecialConditionDueDateProps) {
  const onDueDateChange = (newCondition: FormCondition) => {
    onChange({
      ...newCondition,
      conditionType:
        newCondition.conditionType ??
        (newCondition.condition === Condition.NdaysFromDate ||
        newCondition.condition === Condition.AsPerContract ||
        newCondition.condition === Condition.OnDate
          ? ConditionType.Contract
          : undefined),
    });
  };

  return (
    <AgxOnOrDaysFrom
      id={id}
      label="Due Date"
      condition={dueDate ?? {}}
      conditionsToIncludeInOn={conditionsToInclude}
      conditionsToIncludeInDaysFrom={conditionsToInclude}
      specialConditions={specialConditions}
      campaignId={campaignId}
      onChange={onDueDateChange}
      validate={validate}
      contractDateType={ContractDateType.ContractDate}
      includeContractDateTypeInOnOptions={false}
      onIsValidChange={() => {}}
    />
  );
}
